export const WALLETS_STORE_MUTATIONS = Object.freeze({
  SET_WALLET_DATA: 'wallets/setWalletData',
  SET_WALLETS: 'setWallets',
  SET_MOBILE_OPERATOR_CODES: 'setMobileOperatorCodes',
  SET_ERRORS: 'setErrors',
  CLEAR_ERRORS: 'clearErrors',
});

export const WALLETS_STORE_GETTERS = Object.freeze({
  IS_PHONE_HAVE_VALID_OPERATOR_CODE: 'wallets/isPhoneHaveValidOperatorCode',
});

export const WALLET_KEYS = Object.freeze({
  TYPE: 'type',
  NUMBER: 'number',
});

export const ERROR_KEYS = Object.freeze({
  UPDATE_WALLET_INFO: 'updateWalletInfo',
});
